import { render, staticRenderFns } from "./UserAuth.vue?vue&type=template&id=70c72fef&scoped=true&"
import script from "./UserAuth.vue?vue&type=script&lang=js&"
export * from "./UserAuth.vue?vue&type=script&lang=js&"
import style0 from "./UserAuth.vue?vue&type=style&index=0&id=70c72fef&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c72fef",
  null
  
)

export default component.exports